import {Box, Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'

import {Body} from '../../components/Body/Body'
import {renderWidget} from '../index@desktop'
import {type SectionProps as Props} from '../types'
import {groupByOptionType, toHeader} from './Parcel@desktop.utils'

const root = css`
  margin: ${spacing(1.5, 2, 1)};
`

export function ParcelDesktop(props: Props): ReactElement {
  const {headers, parcelSize, whatsInside, content} = groupByOptionType(props)
  const i18n = useI18n()

  return (
    <Grid xs={12} item>
      <Paper padding="none" radius="L">
        <Grid container>
          {headers.map(header => (
            <Grid key={header.widget_id} xs={12} item>
              <Box ml="s" mt="s">
                {renderWidget(toHeader(header))}
              </Box>
            </Grid>
          ))}
          <Grid xs={12} item>
            <div className={root}>
              <Box flexDirection="column" gap="m">
                <Body
                  lead={
                    <>
                      <Typography mt="s" thickness="medium" variant="body2">
                        {i18n('ndd.delivery-method.field.cargo-size.title', 'Размер посылки')}
                      </Typography>
                    </>
                  }
                  tail={
                    <>
                      {parcelSize.map(renderWidget)}
                      {content.map(renderWidget)}
                    </>
                  }
                />
                <Body
                  lead={
                    <>
                      <Typography mt="m" thickness="medium" variant="body2">
                        {i18n('ndd.delivery-method.field.cargo-details.title', 'Что везем')}
                      </Typography>
                    </>
                  }
                  tail={<>{whatsInside.map(renderWidget)}</>}
                />
              </Box>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}
